import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { emissorSyncingCards } from '@ibk/shared-assets';
import { useTranslation } from '@ibk/shared-translation';
import { Card, Icon, Loading } from '@ibk/shared-ui';
import { BenefitsTimeline } from '../../components/BenefitsTimeline/BenefitsTimeline';
import { useContractStatusTracking } from '../../hooks/useContractStatusTracking';
import { formatContractDateShort } from '../../utils/contractStatusUtils';
import styles from './WaitingApprovalPage.module.css';
const buildSyncingSteps = (contract) => {
    const createdDate = formatContractDateShort(contract.createdAt);
    return [
        {
            id: 'request',
            titleKey: 'benefits.timeline.request.title',
            status: 'completed',
            date: createdDate,
            icon: 'checkCircle',
        },
        {
            id: 'contract-approved',
            titleKey: 'benefits.timeline.contract-approved.title',
            status: 'completed',
            date: createdDate,
            icon: 'checkCircle',
        },
        {
            id: 'sync-employees',
            titleKey: 'benefits.timeline.sync-employees.title',
            status: 'current',
            date: null,
            icon: 'status',
        },
    ];
};
const HeaderBlock = () => {
    const { t } = useTranslation();
    return (_jsxs("div", { className: styles.headerSection, "data-testid": 'waiting-approval-header', children: [_jsxs("div", { className: styles.titleContainer, children: [_jsx(Icon, { name: 'faceSmileWinkl', variant: 'mask', tintColor: 'var(--text-primary-medium)', className: styles.headerIcon }), _jsxs("h1", { className: styles.mainTitle, children: [_jsx("span", { className: styles.titleBold, children: t('benefits.contract-status.title') }), ' ', _jsx("span", { className: styles.titleRegular, children: t('benefits.contract-status.title-highlight') })] })] }), _jsx("p", { className: styles.subtitle, children: t('benefits.waiting-approval.subtitle.approved') })] }));
};
export const WaitingApprovalPage = ({ appDomain }) => {
    const { t } = useTranslation();
    const { contract, isLoading } = useContractStatusTracking({ appDomain });
    if (isLoading || !contract) {
        return _jsx(Loading, { fullScreen: true, message: t('benefits.loading') });
    }
    const timelineSteps = buildSyncingSteps(contract);
    return (_jsxs("div", { className: styles.layoutRoot, "data-testid": 'waiting-approval-page', children: [_jsx("aside", { className: styles.heroIllustration, "data-testid": 'waiting-approval-hero', children: _jsx("img", { src: emissorSyncingCards, alt: '', className: styles.heroImage, "data-testid": 'waiting-approval-hero-image' }) }), _jsx("main", { className: styles.contentPanel, children: _jsxs("div", { className: styles.contentCentered, children: [_jsx(HeaderBlock, {}), _jsx(Card, { shadow: true, padding: 24, className: styles.statusCard, "data-testid": 'waiting-approval-status-card', children: _jsx("div", { className: styles.timelineContainer, children: _jsx(BenefitsTimeline, { steps: timelineSteps, className: styles.compactTimeline }) }) })] }) })] }));
};
